export enum EColors {
  Primary = 'primary',
  Secondary = 'secondary',
  Tertiary = 'tertiary',
  Success = 'success',
  Warning = 'warning',
  Danger = 'danger',
  Light = 'light',
  Medium = 'medium',
  Dark = 'dark',
  Lime = 'lime',
  Default = 'default',
  None = ''
}
